<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <div class="d-flex justify-end mb-2" v-if="canCreateUser">
      <v-btn color="primary" @click="pushToRoute('UserCreate')"><v-icon left>mdi-account-plus</v-icon>{{ trans('user.create') }}</v-btn>
    </div>

    <ajax-table
        ref="usersTable"
        :resource="resourceUrl"
        :filter="filter"
        :headers="[
          {text: 'user.email', value: 'email'},
          {text: 'user.firstname', value: 'firstname'},
          {text: 'user.surname', value: 'surname'},
          {text: 'user.role', value: 'role'},
          {text: 'user.lastLogin', value: 'lastLogin', dateTimeFormat: 'fromNow'},
          {text: '', value: 'actions'},
        ]"
        :page-options="{itemsPerPage: 20, sortBy: ['lastLogin'], sortDesc: [true]}"
        :items-per-page-options="[10, 20, 50]"
    >

      <template v-slot:filters>
        <search v-model="filters.search" />
      </template>

      <template v-slot:item.role="{ item }">
        {{ getUserRoleName(item.role) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <edit-icon-button @click="pushToRoute('User', {userId: item.id})"></edit-icon-button>
        <v-btn
          v-if="canImpersonate(item)"
          icon
          :title="trans('user.impersonate')"
          @click="impersonateUser(item.id)"
        >
          <v-icon color="primary">mdi-account-key</v-icon>
        </v-btn>
      </template>

    </ajax-table>

  </v-container>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import PageHeading from '../components/PageHeading';
import {MainUtils} from '@/utils/main-utils';
import AjaxTable from '@/components/AjaxTable';
import {UserApi} from '@/api/user-api';
import {RouterUtils} from '@/utils/router-utils';
import {mapGetters} from 'vuex';
import Search from '@/components/Search';
import {comparison, or} from 'rsql-builder';
import {like} from '@/lib/custom-rsql-operators';
import {FilterUtils} from '@/utils/filter-utils';
import EditIconButton from '../components/EditIconButton';
import {UserUtils} from '../utils/user-utils';

export default {
  name: 'UsersPage',
  mixins: [
    LocaleUtils,
    RouterUtils,
    MainUtils,
    FilterUtils,
    MainUtils,
    UserUtils
  ],
  components: {
    EditIconButton,
    Search,
    AjaxTable,
    PageHeading,
  },
  data: () => ({
    filters: {
      search: null
    }
  }),
  computed: {
    ...mapGetters({
      auth: 'auth'
    }),
    filter() {
      if(this.filters.search) {
        return this.buildSearchFilter(this.filters.search, ['firstname', 'surname']);
      }

      return [];
    },
    resourceUrl () {
      return UserApi.apiUri;
    },
    pageTitle () {
      return this.trans('user.users');
    },
    canCreateUser() {
      return this.hasAnyPermission('USER_EDIT');
    }
  },
  methods: {
    /** @param user {UserDto} */
    canImpersonate(user) {
      //TODO: use hasManagerUserPermission with manager user id
      return this.hasAnyPermission('USER_IMPERSONATE') && user.role !== 'ADMIN' && user.id !== this.auth.user.id;
    },
    impersonateUser(userId) {
      this.showGlobalLoadingOverlay();
      UserApi.impersonateUser({userId: userId})
      .then(value => {
        this.$auth.fetchUser()
        .then(value => {
          this.gotoLandingPage();
        })
        .finally(() => {
          this.hideGlobalLoadingOverlay();
        })
      })
      .catch(response => {
        this.handleErrorResponse(response);
        this.hideGlobalLoadingOverlay();
      })
    }
  },
  activated () {
    this.$refs.usersTable.loadData();
  }
}
</script>

<style>
</style>
